








































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import { pageData } from "@/store/pageData";
import NewsCard from "../components/NewsCard.vue";
import { FETCH_PAGE_BY_ID, FETCH_NEWS_DATA } from "../store/actions.names";
import SinglenewsCard from "@/components/SinglenewsCard.vue";
import axios from "axios";
import {
  TimelineMax,
  TweenLite,
  Power1,
  TweenMax,
  Expo,
  Power2,
  Power3,
  Power4,
} from "gsap";
@Component({
  name: "NewsIndexPage",
  components: {
    SinglenewsCard,
  },
})
export default class NewsIndexPage extends Vue {
  @Prop() public pageData!: pageDataType;
  @Getter("pageType") public pageType!: string | null;
  @Action(FETCH_NEWS_DATA) fetchNewsData: any;
  public HOST: string = HOST;
  totalPages: number | null = null;
  limit: number = 12;
  currentPage: number = 1;
  newsData: any[] = [];
  public fetchNews() {
    if (this.currentPage < 1) {
      this.currentPage = 1;
    }
    if (this.totalPages != null && this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }
    const offset = (this.currentPage - 1) * this.limit;
    this.fetchNewsData({
      id: this.pageData.id,
      limit: this.limit,
      offset,
    })
      .then((data: any) => {
        this.totalPages = Math.ceil(data.meta.total_count / this.limit);
        this.newsData = data.body[0].value;
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  @Watch("currentPage", {
    immediate: true,
  })
  handleCurrentPageChage(val: number, oldVal: number) {
    if (val != oldVal) {
      this.fetchNews();
    }
  }
 
 public heroimganim() {
    var heroimganim = new TimelineMax({});
    heroimganim
      .from(".banner-wrap", 1.3, {
        y: "100%",
        ease: Expo.easeInOut,
        clearProps: "all",
      })
      .from(".banner-wrap img", 0.7, {
        y: 0,
        scale: 1.2,
        ease: Power2.easeInOut,
        clearProps: "all",
      })
      .staggerFrom(
        ".banner-text",
        0.8,
        {
          autoAlpha: 0,
          height: 0,
          ease: Expo.easeInOut,
          clearProps: "all",
        },
        0.01,
        "-=.3"
      )
      .staggerFrom(
        ".banner-text h1",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".banner-text p",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      );
  }


  public mounted() {
    this.heroimganim();
  }
}
